<template>
    <!-- 中心概况 -->
    <div class="general">
        <div class="banner">
            <div class="banner-inner">
                <h2 class="title">中心概况</h2>
                <ul class="menu-list flex-align">
                    <li v-for="(item,index) in menuList" :key="index" class="menu-item csp"
                        :class="{'active-menu':activeMenu == index}" @click="chooseMenu(index)">
                        {{item.title}}
                    </li>
                </ul>
            </div>
        </div>
        <router-view class="general-view"></router-view>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeMenu: 0,
                menuList: [{
                        title: '中心简介',
                        herf: 'introduction'
                    },
                    {
                        title: '中心优势',
                        herf: 'advantage'
                    },
                    {
                        title: '机构设置',
                        herf: 'organ'
                    },
                    {
                        title: '中心荣誉',
                        herf: 'honour'
                    },
                    {
                        title: '联系我们',
                        herf: 'contactus'
                    }
                ],
            }
        },
        methods: {
            chooseMenu(index) {
                this.activeMenu = index;
                this.$router.push(`${this.menuList[index].herf}`)
            },
        },
        mounted() {
            this.menuList.map((item, index) => {
                if (item.herf == this.$route.name) {
                    this.activeMenu = index;
                }
            })
        }
    }
</script>

<style lang="less" scoped>
    .general {
        .banner {
            background-image: url("../../assets/general/banner.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 56vh;
            max-height: 530px;
            min-height: 360px;
            padding-left: 6.9%;
            position: relative;

            .banner-inner {
                position: absolute;
                width: 100%;
                bottom: 8%;
            }


            .title {
                font-size: 48px;
                color: #fff;
                margin-bottom: 2.5%;
                letter-spacing: 2px;
            }

            .menu-list {
                padding-right: 50%;
            }

            .menu-item {
                color: #fff;
                font-size: 30px;
                // margin-bottom: 7.3%;
                letter-spacing: 2px;
                position: relative;
                width: 25%;
                font-weight: 300;

                &.active-menu {
                    font-weight: 400;
                }

                &.active-menu::before {
                    position: absolute;
                    content: " ";
                    width: 23px;
                    height: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -33px;
                    background-image: url("../../assets/business/arrow.png");
                }
            }
        }

        .general-view {
            background-image: url("../../assets/business/bg.png");
            padding: 0 0 80%;
            background-repeat: no-repeat;
            background-position: bottom;
        }


        @media screen and (max-width:1850px) {
            .banner {
                .title {
                    font-size: 40px;
                }

                .menu-item {
                    font-size: 25px;
                }
            }
        }

        @media screen and (max-width:1450px) {
            .banner {
                // height: 530px;

                .title {
                    font-size: 31px;
                }

                .menu-item {
                    font-size: 20px;
                }
            }

        }

        @media screen and (max-width:1150px) {
            .banner {
                .title {
                    font-size: 25px;
                }

                .menu-item {
                    font-size: 16px;
                }
            }
        }
    }
</style>